module.exports = __webpack_public_path__ + "static/img/dkzg1.3ba947c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/dkzg1.jpg
// module id = 4N8p
// module chunks = 0